module.exports = __webpack_public_path__ + "static/tutor-screen-0676a1a16fa84c3a50bd689bca632d32.png";